"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.environmentsSchema = exports.environmentsRawSchema = exports.environmentsRaw = exports.environments = void 0;
var z = _interopRequireWildcard(require("zod"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// DO NOT EDIT!
// This file was autogenerated from Configuration manager API
// Endpoint: https://configurationmanager.oriflame.com/hierarchy/environments/config.json
// Run `npm run codegen` to regenerate.

const environmentsRaw = exports.environmentsRaw = ['DEV', 'LIVE', 'STG', 'UAT'];
const environments = exports.environments = ['dev', 'live', 'stg', 'uat'];
const environmentsRawSchema = exports.environmentsRawSchema = z.enum(environmentsRaw);
const environmentsSchema = exports.environmentsSchema = z.enum(environments);
//# sourceMappingURL=Environment.js.map